import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { speedFeatures } from '@/mocks/home';

const SpeedFeatures = () => (
  <section id="speed" className="border-b border-background-200 bg-background-100 py-16 md:py-24">
    <div className="mx-auto w-full max-w-shell px-4 md:px-8">
      <Reveal>
        <SectionHeading
          kicker="极速播放体验"
          title="为什么看料社几乎不用等"
          desc="从预加载到线路调度，我们把「秒开」和「不卡顿」拆成了四个可以量化的指标，每一条都能量出结果。"
        />
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
        {speedFeatures.map((feature, index) => (
          <Reveal key={feature.title} delay={index * 80}>
            <article className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${feature.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                {feature.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                {feature.desc}
              </p>
              <div className="mt-5 flex items-baseline gap-2 border-t border-background-200 pt-4">
                <span className="font-heading text-2xl font-semibold text-primary-600">
                  {feature.metric}
                </span>
                <span className="text-[11px] font-label text-foreground-500">{feature.metricLabel}</span>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default SpeedFeatures;